import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import BranchDto from '@/models/Branches/BranchDto';
import BusinessHoursDto from '@/models/BusinessHours/BusinessHoursDto';
import AgencyGroupDto from '@/models/AgencyGroups/AgencyGroupDto';
import ConversationTopicDto from '@/models/ConversationTopics/ConversationTopicDto';

export default class DeskDto extends BaseAgencyScopeEntityDto {
    status = 0;
    name = '';
    branchId = '';
    branch: BranchDto = new BranchDto();
    businessHoursId = '';
	businessHours: BusinessHoursDto = new BusinessHoursDto();
	// isBusinessHoursNotificationEnabled: boolean = false;
	// businessHoursGroupId: string = '';
	// businessHoursGroup: AgencyGroupDto = new AgencyGroupDto();
	// isOutOfHoursNotificationEnabled: boolean = false;
	// outOfHoursGroupId: string = '';
	// outOfHoursGroup: AgencyGroupDto = new AgencyGroupDto();
	conversationTopic: ConversationTopicDto = null;
	conversationTopicId = '';
	// External accounting system fields
	externalAccountingSystemShiftHoursAccount = '';
	externalAccountingSystemTravelHoursAccount = '';
	externalAccountingSystemDistanceAccount = '';
	externalAccountingSystemPlacementAccount = '';
	externalAccountingSystemShiftHoursCategory1 = '';
	externalAccountingSystemTravelHoursCategory1 = '';
	externalAccountingSystemDistanceCategory1 = '';
	externalAccountingSystemPlacementCategory1 = '';
	externalAccountingSystemShiftHoursCategory2 = '';
	externalAccountingSystemTravelHoursCategory2 = '';
	externalAccountingSystemDistanceCategory2 = '';
	externalAccountingSystemPlacementCategory2 = '';
	// External payroll system fields
	externalPayrollSystemId = '';
}